import React, { useEffect, useState } from 'react';
import {
    styled,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TableCell,
    Typography,
    Box,
    Grid,
    Card,
    Chip,
    CircularProgress,
    Button,
    Autocomplete,
    TextField
} from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import axios from './../../axios/api';
import jMoment from 'moment-jalaali';

const StyledTablePagination = styled(TablePagination)(({ theme }) => ({
    '& .MuiTablePagination-actions .Mui-disabled': {
        color: '#ccc',
    },
    '& .MuiTablePagination-actions': {
        color: 'rgba(0, 0, 0, 0.54)',
    },
}));

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

function TransactionPage() {
    const [Data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalResults, setTotalResults] = useState(0);
    const [inputValue, setInputValue] = useState('');
    const [LoadingUser, setLoadingUser] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [DataUser, setDataUser] = useState([]);
    const [abortController, setAbortController] = useState(null);

    const statusOptions = [
        { label: 'در انتظار', value: 'pend' },
        { label: 'موفق', value: 'success' },
        { label: 'ناموفق', value: 'faild' },
    ];

    useEffect(() => {
        GetDataUser();
    }, [inputValue]);

    useEffect(() => {
        GetData();
    }, [page, rowsPerPage]);

    useEffect(() => {
        // Cleanup function to abort ongoing requests on unmount
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, [abortController]);

    const createAbortController = () => {
        if (abortController) {
            abortController.abort();
        }
        const controller = new AbortController();
        setAbortController(controller);
        return controller;
    };

    const GetData = async (resetPage = false) => {
        if (resetPage) setPage(1);
        const controller = createAbortController();
        try {
            setIsLoading(true);
            let url = `/admin/transaction?is_paginate=true&count_of_page=${rowsPerPage}`;
            if (selectedUser) url += `&user_id=${selectedUser?.id}`;
            if (selectedStatus) url += `&status=${selectedStatus.value}`;

            const res = await axios.get(`${url}&page=${resetPage ? 1 : page}`, { signal: controller.signal });
            setData(res.data?.data?.data?.data);
            setTotalResults(res.data?.data?.data?.total);
        } catch (e) {
            if (e.name !== 'AbortError') {
                console.log(e.response, 'eeeeeeeee');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const GetDataUser = async () => {
        const controller = createAbortController();
        try {
            setLoadingUser(true);
            let url = `/admin/user`;
            if (inputValue) url += `?search=${inputValue}&count_limit=5`;
            const res = await axios.get(`${url}`, { signal: controller.signal });
            setDataUser(res.data?.data?.data);
        } catch (e) {
            if (e.name !== 'AbortError') {
                console.log(e.response, 'eeeeeeeee');
            }
        } finally {
            setLoadingUser(false);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage + 1); // Adjusting for the server's 1-based index
    };

    const formattedPrice = (price) => {
        return new Intl.NumberFormat('en-US').format(price);
    };

    const handleFilter = () => {
        GetData(true);
    };

    return (
        <Grid container spacing={0} sx={{ direction: 'ltr' }}>
            <Grid item xs={12} lg={12}>
                <Card variant="outlined">
                    <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                        <Grid item lg={5} md={5} sm={12}>
                            <Autocomplete
                                options={DataUser}
                                getOptionLabel={(option) => option.name || ''}
                                onInputChange={(event, newInputValue) => {
                                    setInputValue(newInputValue);
                                }}
                                onChange={(event, newValue) => {
                                    setSelectedUser(newValue ? newValue : null);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="کاربران"
                                        variant="outlined"
                                        placeholder="نام کاربر را انتخاب کنید"
                                        fullWidth
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {LoadingUser ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                                ListboxProps={{ style: { direction: 'rtl', textAlign: 'right', overflow: 'hidden' } }} // Ensures the list is RTL
                                loading={LoadingUser}
                                loadingText={
                                    <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <span style={{ direction: 'rtl', textAlign: 'right', width: '100%' }}>
                                            در حال جستجو...
                                        </span>
                                    </span>
                                }
                                noOptionsText={
                                    <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <span style={{ direction: 'rtl', textAlign: 'right', width: '100%' }}>
                                            هیچ کاربری یافت نشد
                                        </span>
                                    </span>
                                }
                            />
                        </Grid>
                        <Grid item lg={5} md={5} sm={12}>
                            <Autocomplete
                                options={statusOptions}
                                getOptionLabel={(option) => option.label}
                                onChange={(event, newValue) => {
                                    setSelectedStatus(newValue ? newValue : null);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="وضعیت تراکنش"
                                        variant="outlined"
                                        placeholder="وضعیت تراکنش را انتخاب کنید"
                                        fullWidth
                                    />
                                )}
                                ListboxProps={{ style: { direction: 'rtl', textAlign: 'right', overflow: 'hidden' } }} // Ensures the list is RTL
                                noOptionsText={
                                    <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <span style={{ direction: 'rtl', textAlign: 'right', width: '100%' }}>
                                            هیچ وضعیتی یافت نشد
                                        </span>
                                    </span>
                                }
                            />
                        </Grid>
                        <Grid item lg={2} md={2} sm={12}>
                            <Button
                                onClick={handleFilter}
                                sx={{ padding: '16.5px 14px' }}
                                color="secondary"
                                fullWidth
                                variant="contained"
                                size="large"
                            >
                                <Typography color="white">فیلتر</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 2 }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <>
                            {Data.length === 0 ? (
                                <Typography variant="h6" color="textSecondary" align="center" sx={{ p: 2 }}>
                                    داده‌ای وجود ندارد
                                </Typography>
                            ) : (
                                <>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    <Typography color="textSecondary" variant="h6">
                                                        تاریخ تراکنش
                                                    </Typography>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    <Typography color="textSecondary" variant="h6">
                                                        مبلغ تراکنش(ريال)
                                                    </Typography>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    <Typography color="textSecondary" variant="h6">
                                                        وضعیت تراکنش
                                                    </Typography>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    <Typography color="textSecondary" variant="h6">
                                                        نام کاربر
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Data.map((TransItem) => (
                                                <TableRow key={TransItem.id}>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <Typography variant="body2">
                                                            {jMoment(TransItem?.created_at).local('fa').format('jYYYY/jMM/jDD')}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <Typography variant="body2">{formattedPrice(TransItem.amount)}</Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <Chip
                                                            label={TransItem.status === 'success' ? 'موفق' : TransItem.status === 'pend' ? 'در انتظار' : 'ناموفق'}
                                                            color={TransItem.status === 'success' ? 'success' : TransItem.status === 'pend' ? 'warning' : 'error'}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <Typography variant="body2">
                                                            {TransItem?.user?.name + ' ' + TransItem?.user?.family}
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    <StyledTablePagination
                                        component="div"
                                        count={totalResults}
                                        rowsPerPage={rowsPerPage}
                                        page={page - 1} // Adjusting for the 0-based index of TablePagination
                                        onPageChange={handleChangePage}
                                        rowsPerPageOptions={[]} // Hide rows per page dropdown
                                        labelRowsPerPage="" // Hide label
                                        showFirstButton
                                        showLastButton
                                    />
                                </>
                            )}
                        </>
                    )}
                </Card>
            </Grid>
        </Grid>
    );
}

export default TransactionPage;
